var cov_23b1lcxnvu = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Cascader/filter.tsx",
      hash = "8498b9af3ab3a8af9f4047f981f3bb899481fa05",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Cascader/filter.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 76,
          column: 65
        }
      },
      "1": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 18
        }
      },
      "2": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 54
        }
      },
      "3": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 29,
          column: 7
        }
      },
      "4": {
        start: {
          line: 33,
          column: 44
        },
        end: {
          line: 33,
          column: 54
        }
      },
      "5": {
        start: {
          line: 34,
          column: 25
        },
        end: {
          line: 34,
          column: 35
        }
      },
      "6": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 30
        }
      },
      "7": {
        start: {
          line: 35,
          column: 19
        },
        end: {
          line: 35,
          column: 30
        }
      },
      "8": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 39,
          column: 8
        }
      },
      "9": {
        start: {
          line: 36,
          column: 67
        },
        end: {
          line: 36,
          column: 87
        }
      },
      "10": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 39
        }
      },
      "11": {
        start: {
          line: 37,
          column: 33
        },
        end: {
          line: 37,
          column: 39
        }
      },
      "12": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 34
        }
      },
      "13": {
        start: {
          line: 43,
          column: 40
        },
        end: {
          line: 43,
          column: 50
        }
      },
      "14": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 46
        }
      },
      "15": {
        start: {
          line: 44,
          column: 22
        },
        end: {
          line: 44,
          column: 46
        }
      },
      "16": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 32
        }
      },
      "17": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 49,
          column: 7
        }
      },
      "18": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 51
        }
      },
      "19": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 14
        }
      },
      "20": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 56,
          column: 21
        }
      },
      "21": {
        start: {
          line: 52,
          column: 19
        },
        end: {
          line: 52,
          column: 40
        }
      },
      "22": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 55,
          column: 9
        }
      },
      "23": {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 54,
          column: 51
        }
      },
      "24": {
        start: {
          line: 60,
          column: 27
        },
        end: {
          line: 60,
          column: 37
        }
      },
      "25": {
        start: {
          line: 61,
          column: 37
        },
        end: {
          line: 61,
          column: 47
        }
      },
      "26": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 105
        }
      },
      "27": {
        start: {
          line: 62,
          column: 21
        },
        end: {
          line: 62,
          column: 105
        }
      },
      "28": {
        start: {
          line: 63,
          column: 19
        },
        end: {
          line: 63,
          column: 33
        }
      },
      "29": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 74,
          column: 7
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 16
          },
          end: {
            line: 12,
            column: 17
          }
        },
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 76,
            column: 65
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        loc: {
          start: {
            line: 23,
            column: 46
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 23
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 5
          }
        },
        loc: {
          start: {
            line: 32,
            column: 14
          },
          end: {
            line: 40,
            column: 5
          }
        },
        line: 32
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 36,
            column: 52
          },
          end: {
            line: 36,
            column: 53
          }
        },
        loc: {
          start: {
            line: 36,
            column: 67
          },
          end: {
            line: 36,
            column: 87
          }
        },
        line: 36
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 36,
            column: 108
          },
          end: {
            line: 36,
            column: 109
          }
        },
        loc: {
          start: {
            line: 36,
            column: 116
          },
          end: {
            line: 39,
            column: 7
          }
        },
        line: 36
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        loc: {
          start: {
            line: 42,
            column: 37
          },
          end: {
            line: 57,
            column: 5
          }
        },
        line: 42
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 51,
            column: 30
          },
          end: {
            line: 51,
            column: 31
          }
        },
        loc: {
          start: {
            line: 51,
            column: 36
          },
          end: {
            line: 56,
            column: 7
          }
        },
        line: 51
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        },
        loc: {
          start: {
            line: 59,
            column: 13
          },
          end: {
            line: 75,
            column: 5
          }
        },
        line: 59
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 30
          }
        }, {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 30
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 39
          }
        }, {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 39
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 46
          }
        }, {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 46
          }
        }],
        line: 44
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 49,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 49,
            column: 7
          }
        }, {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 49,
            column: 7
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }, {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }],
        line: 53
      },
      "5": {
        loc: {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 62,
            column: 105
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 62,
            column: 105
          }
        }, {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 62,
            column: 105
          }
        }],
        line: 62
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Cascader/filter.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { getKey } from '../utils/uid';
import { Component } from '../component';
import { getFilterTree } from '../utils/tree';
export default (function (Origin) {
  var _class, _temp;

  cov_23b1lcxnvu.f[0]++;
  cov_23b1lcxnvu.s[0]++;
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(CascaderFilter, _Component);

    var _super = _createSuper2(CascaderFilter);

    function CascaderFilter(props) {
      var _this;

      _classCallCheck(this, CascaderFilter);

      cov_23b1lcxnvu.f[1]++;
      cov_23b1lcxnvu.s[1]++;
      _this = _super.call(this, props);
      _this.firstMatchNode = void 0;
      _this.timer = void 0;
      cov_23b1lcxnvu.s[2]++;
      _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this));
      cov_23b1lcxnvu.s[3]++;
      _this.state = {
        filterText: '',
        filter: null
      };
      return _this;
    }

    _createClass(CascaderFilter, [{
      key: "getData",
      value: function getData() {
        var _this2 = this;

        cov_23b1lcxnvu.f[2]++;

        var _ref = (cov_23b1lcxnvu.s[4]++, this.props),
            data = _ref.data,
            childrenKey = _ref.childrenKey,
            keygen = _ref.keygen;

        var _ref2 = (cov_23b1lcxnvu.s[5]++, this.state),
            filter = _ref2.filter;

        cov_23b1lcxnvu.s[6]++;

        if (!filter) {
          cov_23b1lcxnvu.b[0][0]++;
          cov_23b1lcxnvu.s[7]++;
          return data;
        } else {
          cov_23b1lcxnvu.b[0][1]++;
        }

        cov_23b1lcxnvu.s[8]++;
        return getFilterTree(data, filter, undefined, function (node) {
          cov_23b1lcxnvu.f[3]++;
          cov_23b1lcxnvu.s[9]++;
          return getKey(node, keygen);
        }, childrenKey, true, function (node) {
          cov_23b1lcxnvu.f[4]++;
          cov_23b1lcxnvu.s[10]++;

          if (_this2.firstMatchNode) {
            cov_23b1lcxnvu.b[1][0]++;
            cov_23b1lcxnvu.s[11]++;
            return;
          } else {
            cov_23b1lcxnvu.b[1][1]++;
          }

          cov_23b1lcxnvu.s[12]++;
          _this2.firstMatchNode = node;
        });
      }
    }, {
      key: "handleFilter",
      value: function handleFilter(filterText) {
        var _this3 = this;

        cov_23b1lcxnvu.f[5]++;

        var _ref3 = (cov_23b1lcxnvu.s[13]++, this.props),
            filterDelay = _ref3.filterDelay,
            onFilter = _ref3.onFilter;

        cov_23b1lcxnvu.s[14]++;

        if (this.timer) {
          cov_23b1lcxnvu.b[2][0]++;
          cov_23b1lcxnvu.s[15]++;
          clearTimeout(this.timer);
        } else {
          cov_23b1lcxnvu.b[2][1]++;
        }

        cov_23b1lcxnvu.s[16]++;
        this.firstMatchNode = null;
        cov_23b1lcxnvu.s[17]++;

        if (filterText.length === 0) {
          cov_23b1lcxnvu.b[3][0]++;
          cov_23b1lcxnvu.s[18]++;
          this.setState({
            filter: null,
            filterText: filterText
          });
          cov_23b1lcxnvu.s[19]++;
          return;
        } else {
          cov_23b1lcxnvu.b[3][1]++;
        }

        cov_23b1lcxnvu.s[20]++;
        this.timer = setTimeout(function () {
          cov_23b1lcxnvu.f[6]++;
          var fn = (cov_23b1lcxnvu.s[21]++, onFilter(filterText));
          cov_23b1lcxnvu.s[22]++;

          if (typeof fn === 'function') {
            cov_23b1lcxnvu.b[4][0]++;
            cov_23b1lcxnvu.s[23]++;

            _this3.setState({
              filter: fn,
              filterText: filterText
            });
          } else {
            cov_23b1lcxnvu.b[4][1]++;
          }
        }, filterDelay);
      }
    }, {
      key: "render",
      value: function render() {
        cov_23b1lcxnvu.f[7]++;

        var _ref4 = (cov_23b1lcxnvu.s[24]++, this.props),
            onFilter = _ref4.onFilter;

        var _ref5 = (cov_23b1lcxnvu.s[25]++, this.state),
            filterText = _ref5.filterText,
            filter = _ref5.filter;

        cov_23b1lcxnvu.s[26]++;

        if (!onFilter) {
          cov_23b1lcxnvu.b[5][0]++;
          cov_23b1lcxnvu.s[27]++;
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, this.props, {
              sourceData: this.props.data,
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 62,
                columnNumber: 29
              }
            }))
          );
        } else {
          cov_23b1lcxnvu.b[5][1]++;
        }

        var data = (cov_23b1lcxnvu.s[28]++, this.getData());
        cov_23b1lcxnvu.s[29]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, this.props, {
            data: data,
            sourceData: this.props.data,
            filterText: filterText,
            onFilter: this.handleFilter,
            filterDataChange: filter,
            firstMatchNode: this.firstMatchNode,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 65,
              columnNumber: 9
            }
          }))
        );
      }
    }]);

    return CascaderFilter;
  }(Component), _class.defaultProps = {
    filterDelay: 400,
    childrenKey: 'children'
  }, _temp;
});